import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { State } from '@app/shared/interfaces/state';
import { AppConfig } from '@config/app.config';
import { StatusRepository } from '@core/repositories/status.repository';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiStatusRepository implements StatusRepository {
  public url = this.appConfig.URL + '/segments/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(state: State): Observable<any> {
    const data = {
      data: {
        id: state.id,
        type: 'Segment',
        attributes: {
          name: state.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(state: State): Observable<any> {
    const data = {
      data: {
        id: state.id,
        type: 'Segment',
        attributes: {
          name: state.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
